import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { ModalService } from '@bling-fe/shared/modals/base-modal';
import { SelectPostScopeModalComponent } from './select-post-scope-modal/select-post-scope-modal.component';
import { ArticleScope } from '@bling-fe/shared/utils';

@Component({
  selector: 'fl-article-scope-select',
  standalone: true,
  imports: [CommonModule, TranslateModule, IonicModule],
  template: `
    <div class="container">
      <ion-button
        size="default"
        fill="outline"
        (click)="showArticleScopeModal()"
      >
        {{ 'UI_COMPONENTS.ARTICLE_SCOPE_SELECT.CHANGE' | translate }}
      </ion-button>
      <ng-container *ngIf="selectedScope">
        {{ currentSelection() }}
      </ng-container>
    </div>
  `,
  styles: `
    .container {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleScopeSelectComponent {
  @Input() selectedScope!: ArticleScope;

  @Output() selectedScopeChange = new EventEmitter<ArticleScope>();

  private modalService = inject(ModalService);
  private translateService = inject(TranslateService);

  showArticleScopeModal() {
    this.modalService
      .presentAndGetResult(SelectPostScopeModalComponent, {
        value: this.selectedScope
      })
      .then((result: ArticleScope | undefined) => {
        if (!result) return;

        this.selectedScopeChange.emit(result);
      });
  }

  currentSelection(): string {
    if (this.selectedScope.publish_globally) {
      return this.translateService.instant(
        'UI_COMPONENTS.ARTICLE_SCOPE_SELECT.ALL'
      );
    }

    return this.selectedScope.settlements
      .concat(this.selectedScope.groups)
      .map(option => option.title)
      .join(', ');
  }
}
